import React from 'react';
import { Field, FieldArray } from 'redux-form';

import { PreviewAnswers } from '../previewAnswers/PreviewAnswers';

import { QuestionBox } from './questionBox/questionBox';
import { AppTextField } from 'components/form/appTextField';
import { FieldArrayRenderer } from 'components/form/fieldArrayRenderer/fieldArrayRenderer';

export enum SurveyQuestionType {
  short = 'Short answer',
  long = 'Paragraph ',
  // eslint-disable-next-line camelcase,@typescript-eslint/camelcase
  single_choice = 'Single choice',
  // eslint-disable-next-line camelcase,@typescript-eslint/camelcase
  multiple_choice = 'Multiple choice',
  email = 'E-mail',
}

export const PreviewQuestion = (props: any) => {
  const { name, index } = props;

  return (
    <QuestionBox>
      <div>#{index + 1} question</div>
      <AppTextField name={`${name}.question`} label="Question" disabled placeholder="-" />
      <AppTextField
        name={`${name}.type`}
        label="Type"
        disabled
        placeholder="-"
        format={v => SurveyQuestionType[v] || v}
      />
      <Field
        name={`${name}.answers`}
        component={({ input: { value } }: any) => {
          if (value) {
            return (
              <div>
                <div>Answers</div>
                <FieldArray name={`${name}.answers`} component={FieldArrayRenderer} fieldComponent={PreviewAnswers} />
              </div>
            );
          }

          return null;
        }}
      />
      <Field
        name={`${name}.excludedDomain`}
        component={({ input: { value } }: any) => {
          if (value) {
            return <AppTextField name={`${name}.excludedDomain`} label="Excluded domain" disabled placeholder="-" />;
          }

          return null;
        }}
      />
    </QuestionBox>
  );
};
